import { errorNotifier } from "../components/NotificationHandler";
import http, { AUTH_ROUTES } from "../services/api";
import { PRIMARY_HEX } from "../theme/primary";

export const getUserProfile = async (userId, setUserProfile, setLoading) => {
  try {
    const data = await http.get(AUTH_ROUTES.GET_USER(userId));
    // console.log("data", data);
    setUserProfile(data?.data?.userDetails?.data?.users?.[0]);
    setLoading(false);
    // console.log("userrrrr", data?.data?.userDetails?.data?.users?.[0]?.streetId?.estateId?.colorSetting);
    localStorage.setItem("brandColor", PRIMARY_HEX);
    return data;
  } catch (e) {
    setLoading(false);
    console.log("errror", e.response);
    errorNotifier(e.response?.data?.result?.message);
  }
};
